var _path, _path2, _circle, _circle2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgMacMiniIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 22,
    viewBox: "0 0 22 22",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M20.9688 10.1973H20.8746C21.0437 10.6043 20.9234 11.0429 20.625 11.3138V16.5566C20.625 17.0303 20.2393 17.416 19.7656 17.416H2.23438C1.76069 17.416 1.375 17.0303 1.375 16.5566V11.3138C1.22263 11.1766 1.11673 10.9954 1.07201 10.7953C1.02729 10.5953 1.04596 10.3862 1.12544 10.1973H1.03125C0.940082 10.1973 0.852648 10.2335 0.788182 10.2979C0.723716 10.3624 0.6875 10.4498 0.6875 10.541V16.5566C0.6875 17.4098 1.38187 18.1035 2.23438 18.1035H19.7656C20.6181 18.1035 21.3125 17.4098 21.3125 16.5566V10.541C21.3125 10.4498 21.2763 10.3624 21.2118 10.2979C21.1474 10.2335 21.0599 10.1973 20.9688 10.1973Z",
    fill: "#6F767E",
    stroke: "#6F767E",
    strokeWidth: 0.6
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M19.9623 11.916H2.03779C1.80424 11.9173 1.5745 11.8569 1.37172 11.741C1.16893 11.6252 1.00029 11.4579 0.882794 11.256C0.763262 11.0551 0.6988 10.8262 0.695903 10.5924C0.693006 10.3586 0.751777 10.1282 0.866294 9.92433L2.89098 6.27852C3.09976 5.90352 3.40491 5.5911 3.77489 5.37354C4.14486 5.15598 4.56622 5.04118 4.99542 5.04102H17.0054C17.8792 5.04102 18.6842 5.51539 19.1098 6.27852L21.1345 9.92433C21.3675 10.3437 21.3614 10.8415 21.118 11.256C20.8739 11.6692 20.4422 11.916 19.9623 11.916ZM4.99542 5.72852C4.37186 5.72852 3.79573 6.06745 3.49254 6.61264L1.46786 10.2578C1.4119 10.357 1.38314 10.4693 1.38447 10.5833C1.3858 10.6972 1.41717 10.8088 1.47542 10.9068C1.53254 11.0052 1.61463 11.0867 1.71337 11.1432C1.81212 11.1997 1.92403 11.2291 2.03779 11.2285H19.9623C20.196 11.2285 20.4064 11.1082 20.5247 10.9068C20.6429 10.7053 20.6464 10.4626 20.5322 10.2578L18.5075 6.61195C18.3584 6.34421 18.1405 6.12115 17.8763 5.96584C17.612 5.81053 17.3111 5.7286 17.0047 5.72852H4.99542Z",
    fill: "#6F767E",
    stroke: "#6F767E",
    strokeWidth: 0.6
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 18.5001,
    cy: 15.4996,
    r: 0.9,
    fill: "#6F767E"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 16.2,
    cy: 15.4996,
    r: 0.9,
    fill: "#6F767E"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMacMiniIcon);
export default __webpack_public_path__ + "static/media/Mac_mini_icon.172d13606c02ab503bb2112e097223f8.svg";
export { ForwardRef as ReactComponent };